(() => {
  const initialized = new WeakSet();
  const init = (scope = document) => {
    scope.querySelectorAll('.bec-instagram-section').forEach((section) => {
      if (initialized.has(section)) return;
      const labels = section.querySelector('[data-bec-instagram-labels]');
      if (!labels) return;
      initialized.add(section);
      const setLabel = (element, label) => {
        if (element && label && element.getAttribute('aria-label') !== label) {
          element.setAttribute('aria-label', label);
        }
      };
      const update = () => {
        const feed = section.querySelector('#insta-feed');
        if (!feed) return;
        setLabel(feed.querySelector('button.instafeed-new-arrow-prev'), labels.dataset.previous);
        setLabel(feed.querySelector('button.instafeed-new-arrow-next'), labels.dataset.next);
        feed.querySelectorAll('[role="link"][data-instafeed-open-id]').forEach((post, index) => {
          const number = (post.getAttribute('aria-label') || '').match(/\d+/)?.[0] || String(index + 1);
          setLabel(post, labels.dataset.openPost?.replace('%number%', number));
        });
      };
      update();
      new MutationObserver(update).observe(section, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label']
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', () => init());
})();
